import { createTheme } from "@mui/material/styles";

// Soft, light theme matching the original site - charcoal ink on greys and lavender
const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#2F2B36",
      contrastText: "#fff",
    },
    secondary: {
      main: "#fff",
      contrastText: "#2F2B36",
    },
    background: {
      default: "#F7F7F7",
      paper: "#fff",
    },
    text: {
      primary: "#2F2B36",
      secondary: "#5f5c66",
    },
  },
  typography: {
    fontFamily: "\"Wix Madefor Text\", Helvetica, Arial, sans-serif",
    button: {
      textTransform: "none",
      fontSize: "1rem",
      fontWeight: 400,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          padding: "10px 30px",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
        sizeLarge: {
          padding: "12px 32px",
          fontSize: "1.05rem",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#2F2B36",
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          "&:before": {
            borderBottomColor: "#76747B",
          },
        },
      },
    },
  },
});

export default theme;
